"use strict";

exports.__esModule = true;
exports.default = _default;

function _default() {}

;
module.exports = exports.default;